<template>
  <div
    style="background: rgb(241 245 249); min-height: calc(100vh - 60px)"
    class="py-4"
  >
    <b-col md="12">
      <iq-card>
        <template #body>
          <b-row class="">
            <b-col md="2">
              <b-form-group label="Period" label-for="Period">
                <date-picker
                  type="date"
                  range
                  v-model="dateRange"
                  placeholder="Select date range"
                  :style="{ width: '100%' }"
                  @input="fetchVoyageByTrips"
                ></date-picker>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Status" label-for="status">
                <b-form-select
                  plain
                  v-model="params.status"
                  @input="fetchVoyageByTrips"
                >
                  <b-form-select-option value="all">All</b-form-select-option>
                  <b-form-select-option value="progress">
                    Progress
                  </b-form-select-option>
                  <b-form-select-option value="completed">
                    Completed
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Filter Option" label-for="cargo">
                <b-form-select plain v-model="params.filterOption">
                  <b-form-select-option value="all">All</b-form-select-option>
                  <b-form-select-option value="by-project">
                    By Project
                  </b-form-select-option>
                  <b-form-select-option value="by-fleet">
                    By Fleet
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="6" v-if="params.filterOption == 'by-fleet'">
              <b-form-group label="Fleet Name" label-for="fleet-categtory">
                <v-multiselect
                  id="fleet-category"
                  :multiple="true"
                  placeholder="Select Categories"
                  label="name"
                  :options="fleetNameOpt"
                  track-by="code"
                  v-model="params.vehicleIds"
                  @input="fetchVoyageByTrips"
                >
                  <span slot="noResult">
                    Oops! No elements found. Consider changing the search query.
                  </span>
                </v-multiselect>
              </b-form-group>
            </b-col>
            <b-col md="6" v-if="params.filterOption == 'by-project'">
              <b-form-group
                label="Project Name"
                label-for="fleet-categtory"
                class="w-100"
              >
                <v-multiselect
                  id="fleet-category"
                  :multiple="true"
                  placeholder="Select Categories"
                  label="name"
                  :options="projectNameOpt"
                  track-by="code"
                  v-model="params.projectIds"
                  class="w-100"
                  @input="fetchVoyageByTrips"
                >
                  <span slot="noResult">
                    Oops! No elements found. Consider changing the search query.
                  </span>
                </v-multiselect>
              </b-form-group>
            </b-col>
            <!-- <b-col md="2" class="d-flex align-items-end">
              <b-form-group class="w-100">
                <b-button
                  variant="primary"
                  class="w-100"
                  type="button"
                  @click="fetchVoyageByTrips"
                >
                  <i class="fas fa-search"></i>
                  Show Data
                </b-button>
              </b-form-group>
            </b-col> -->
          </b-row>
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="mb-0">
              <strong>Operational Data Running Shipment</strong>
            </h5>
            <!-- <b-button
              variant="outline-primary"
              size="md"
              class="d-flex align-items-center"
              @click="toggleModalFilter"
            >
              <i class="fas fa-sliders"></i>
              <p class="text-truncate m-0"> Filter Data</p>
            </b-button> -->
            <b-button
              variant="outline-primary"
              class="mx-2 d-flex"
              size="md"
              @click="onExportTripRecords"
            >
              <span v-if="exporting" class="spinner-border spinner-border-sm" />
              <div v-else class="d-flex gap-2 align-items-center">
                <span>Export</span>
                <i class="fa fa-download ml-2"></i>
              </div>
            </b-button>
          </div>
          <div style="max-height: 700px" class="overflow-auto">
            <template v-if="list.length > 0">
              <div
                style="max-height: 600px"
                v-for="(state, index) in list"
                :key="index"
              >
                <div
                  style="background-color: #ededed; cursor: pointer"
                  class="d-flex w-100 p-3"
                  @click="toggleRow(`list-${index}`)"
                >
                  <h5 class="text-truncate">
                    <strong>
                      {{ state?.projectSub?.project?.projectName }} -
                      {{ state?.projectSub?.name }}
                    </strong>
                  </h5>
                </div>
                <div
                  class="p-3"
                  v-if="isRowVisible(`list-${index}`)"
                  :class="{
                    'collapsed-row': !isRowVisible(`list-${index}`),
                    'expanded-row': isRowVisible(`list-${index}`),
                  }"
                >
                  <div class="table-responsive">
                    <table
                      class="table table-borderless table-hover"
                      v-for="(trip, tripIndex) in state?.projectSub?.trip"
                      :key="tripIndex"
                    >
                      <thead>
                        <tr>
                          <th
                            v-for="(column, index) in columns"
                            :key="index"
                            class="text-truncate column-primary"
                            :class="{
                              'sticky-column sticky-column-1': index === 0,
                              'sticky-column sticky-column-2': index === 1,
                            }"
                          >
                            {{ column }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td
                            class="text-truncate sticky-column sticky-column-1 bg-white"
                          >
                            <b-badge
                              variant="primary"
                              class="mr-2"
                              v-for="(vehicle, vehicleIndex) in trip.vehicle"
                            >
                              {{ vehicle?.name }}
                            </b-badge>
                          </td>
                          <td
                            class="text-truncate sticky-column sticky-column-2 bg-white"
                          >
                            <b-button
                              variant="outline-primary"
                              @click="
                                handleOpenFreight(
                                  trip,
                                  `${state?.projectSub?.project?.projectName} - ${state?.projectSub?.name}`
                                )
                              "
                            >
                              <i class="fa fa-plus"></i>
                              Input Freight Rate
                            </b-button>
                          </td>
                          <td class="text-truncate">
                            {{
                              trip?.tripRecord?.portLoading?.portName ||
                              trip?.tripRecord?.portLoadingOther
                            }}
                          </td>
                          <td class="text-truncate">
                            {{
                              trip?.tripRecord?.portDischarge?.portName ||
                              trip?.tripRecord?.portDischargeOther
                            }}
                          </td>
                          <td class="text-truncate">
                            {{
                              formatString(
                                trip?.tripRecord?.polGrabType || ''
                              ) ||
                              formatString(trip?.tripRecord?.podGrabType || '')
                            }}
                          </td>
                          <td class="text-truncate text-right text-primary">
                            {{ trip?.tripRecord?.cargoUnloading }}
                          </td>
                          <td class="text-truncate">
                            {{ trip?.tripRecord?.status }}
                          </td>
                          <td class="text-truncate">
                            {{ trip?.tripRecord?.polArrivalTime }}
                          </td>
                          <td class="text-truncate">
                            {{
                              matrixData(
                                'Waiting for Berthing POL',
                                index,
                                tripIndex
                              )
                            }}
                          </td>
                          <td class="text-truncate"></td>
                          <td class="text-truncate">
                            {{
                              matrixData(
                                'Waiting for Loading',
                                index,
                                tripIndex
                              )
                            }}
                          </td>
                          <td class="text-truncate">
                            {{ trip?.tripRecord?.polCommenced }}
                          </td>
                          <td class="text-truncate">
                            {{ trip?.tripRecord?.polCompleted }}
                          </td>
                          <td class="text-truncate">
                            {{ matrixData('Loading', index, tripIndex) }}
                          </td>
                          <td class="text-truncate">
                            {{ trip?.tripRecord?.polCastOut }}
                          </td>
                          <td class="text-truncate">
                            {{ trip?.tripRecord?.polLhv }}
                          </td>
                          <td class="text-truncate">
                            {{ matrixData('Waiting LHV', index, tripIndex) }}
                          </td>
                          <td class="text-truncate">
                            {{ trip?.tripRecord?.polDocOnBoard }}
                          </td>
                          <td class="text-truncate">
                            {{
                              matrixData(
                                'Waiting Document POL',
                                index,
                                tripIndex
                              )
                            }}
                          </td>
                          <td class="text-truncate">
                            {{ trip?.tripRecord?.polDeparture }}
                          </td>
                          <td class="text-truncate">
                            {{
                              matrixData('Waiting Departure', index, tripIndex)
                            }}
                          </td>
                          <td class="text-truncate">
                            {{ trip?.tripRecord?.podArrivalTime }}
                          </td>
                          <td class="text-truncate">
                            {{
                              matrixData('POL Steaming Time', index, tripIndex)
                            }}
                          </td>
                          <td class="text-truncate">
                            {{ trip?.tripRecord?.podAnchorUp }}
                          </td>
                          <td class="text-truncate">
                            {{ trip?.tripRecord?.podBerthing }}
                          </td>
                          <td class="text-truncate"></td>
                          <td class="text-truncate">
                            {{
                              matrixData(
                                'Waiting for Berthing',
                                index,
                                tripIndex
                              )
                            }}
                          </td>
                          <td class="text-truncate">
                            {{ matrixData('Discharge', index, tripIndex) }}
                          </td>
                          <td class="text-truncate">
                            {{ trip?.tripRecord?.podCastOut }}
                          </td>
                          <td class="text-truncate">
                            {{
                              matrixData('Waiting Full Away', index, tripIndex)
                            }}
                          </td>
                          <td class="text-truncate">
                            {{ trip?.tripRecord?.podDeparture }}
                          </td>
                          <td class="text-truncate">
                            {{ trip?.tripRecord?.podArrivalTime }}
                          </td>
                          <td class="text-truncate">
                            {{
                              matrixData('POD Steaming Time', index, tripIndex)
                            }}
                          </td>
                          <td class="text-truncate">
                            {{ matrixData('Total Steaming', index, tripIndex) }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </template>
            <div
              class="d-flex align-items-center justify-content-center w-100 p-3"
              v-else
            >
              <h6 class="text-muted">
                No Data Found. try change filter period
                <strong></strong>
              </h6>
            </div>
          </div>
        </template>
      </iq-card>
    </b-col>
    <b-modal
      v-model="modal.freightRate"
      id="input-freight-rate"
      title="Input Freight Rate"
      centered
      size="xl"
      title-class="title-modal"
      hide-footer
    >
      <FormFreightRate
        :refreshData="refreshData"
        :fleets="fleetNameOpt"
        :tripData="selectedTrip"
        :projectName="selectedProject"
      />
    </b-modal>
  </div>
</template>
<script>
import moment from 'moment'
import {
  fleetsActions,
  projectsActions,
  voyagesActions,
} from '@/src/Utils/helper'
import FormFreightRate from './FormFreightRate.vue'
import { saveAs } from 'file-saver'

export default {
  components: {
    FormFreightRate,
  },
  data() {
    return {
      fleetNameOpt: [],
      projectNameOpt: [],
      filterOptSelected: 'by-fleet',
      exporting: false,
      visibleRows: {},
      dateRange: [
        new Date(moment().startOf('month')),
        new Date(moment().endOf('month')),
      ],
      params: {
        ownership: 'all',
        filterOption: 'all',
        status: 'all',
        // projectIds: [],
        // vehicleIds: [],
        // dateRange: [],
      },
      modal: {
        freightRate: false,
      },
      vehicleSelected: [],
      inputFreightSelected: null,
      columns: [
        'Fleet Name',
        'Freight Rate',
        'POL',
        'POD',
        'Grab Type',
        'Actual COB',
        'Status',
        'Arrival Time POL',
        'Waiting for Berthing',
        'Alongside',
        'Waiting For Loading',
        'Commenced',
        'Completed',
        'Loading',
        'Cast Off',
        'LHV',
        'Waiting LHV',
        'Document on Board',
        'Waiting Document',
        'Time Departure',
        'Waiting Departure',
        'Arrival POD',
        'Steaming Time',
        'Anchor Up',
        'Berthing Process',
        'Alongside',
        'Waiting for Berthing',
        'Discharge',
        'Cast Off',
        'Waiting Full Away',
        'Departure To POD',
        'Arrival Time POD',
        'Steaming Time',
        'Total Steaming Time',
      ],
      rows: [
        {
          showModal: false,
          row: '',
        },
      ],

      selectedProject: '',
      selectedTrip: null,
      list: [],
    }
  },
  mounted() {
    this.fetchVoyageByTrips()
    this.fetchFleets()
    this.fetchProjects()
  },
  watch: {
    'modal.freightRate': {
      immediate: true,
      handler: function () {
        if (!this.modal.freightRate) {
          this.selectedTrip = null
          this.selectedProject = ''
        }
      },
    },
  },
  computed: {
    userVehicles() {
      return this.$store.state.auth.profile.vehicle || []
    },
    vehicleTypes() {
      let vehicleTypes = []

      this.userVehicles.forEach((vehicle) => {
        const vehicleTypeExist = vehicleTypes.find(
          (v) => v.id === vehicle.vehicleType.id
        )
        if (!vehicleTypeExist) {
          vehicle.vehicleType.checked = true
          vehicleTypes.push(vehicle.vehicleType)
        }
      })

      return vehicleTypes
    },
  },
  methods: {
    ...fleetsActions,
    ...projectsActions,
    ...voyagesActions,
    formatString(str) {
      return str
        .split('_') // Pisahkan berdasarkan underscore
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Kapitalisasi setiap kata
        .join(' ') // Gabungkan kembali dengan spasi
    },

    handleOpenFreight(data, projectName) {
      this.selectedTrip = data
      this.selectedProject = projectName

      this.modal.freightRate = true
    },
    toggleRow(id) {
      this.$set(this.visibleRows, id, !this.visibleRows[id])
    },
    isRowVisible(id) {
      return !!this.visibleRows[id]
    },
    matrixData(keyMatrix, index, tripIndex) {
      let matrix = this.list?.[index]?.projectSub?.trip?.[
        tripIndex
      ]?.matrix?.find((obj) => obj?.name === keyMatrix)?.durationFormat
      return matrix
    },

    refreshData() {
      this.fetchVoyageByTrips()
    },

    async fetchFleets() {
      let params = {
        page: 1,
        perPage: 1000,
      }
      try {
        this.fleetNameOpt = []
        const res = await this.getFleets(params)
        res.data.forEach((el) => {
          this.fleetNameOpt.push({
            name: el.name,
            code: el.id,
          })
        })
      } catch (error) {
        console.log(error)
      }
    },
    async fetchProjects() {
      let params = {
        page: 1,
        perPage: 1000,
      }
      try {
        this.projectNameOpt = []
        const res = await this.getProjects(params)
        res.data.data.forEach((el) => {
          this.projectNameOpt.push({
            name: el.projectName,
            code: el.id,
          })
        })
      } catch (error) {
        console.log(error)
      }
    },

    async fetchVoyageByTrips() {
      let params = {
        // vehicleId: Number(this.$route.query.vehicleId),
        ...this.params,
        startDate: this.dateRange?.[0]
          ? moment(this.dateRange?.[0]).format('DD-MM-YYYY')
          : null,
        endDate: this.dateRange?.[1]
          ? moment(this.dateRange?.[1]).format('DD-MM-YYYY')
          : null,
      }

      // Iterate over each property in params
      for (const prop in params) {
        if (params.hasOwnProperty(prop)) {
          // Check conditions for each property and delete if necessary
          if (params[prop] === '' || params[prop] === null) {
            delete params[prop]
          }
        }
      }

      const res = await this.getVoyageTripsByPeriod(params)

      if (res.status == 'success') {
        this.list = res.data.data
      } else {
        this.list = []
      }
    },

    async onExportTripRecords() {
      try {
        this.exporting = true
        let params = {
          ...this.params,
          startDate: this.dateRange?.[0]
            ? moment(this.dateRange?.[0]).format('DD-MM-YYYY')
            : null,
          endDate: this.dateRange?.[1]
            ? moment(this.dateRange?.[1]).format('DD-MM-YYYY')
            : null,
        }

        // Iterate over each property in params
        for (const prop in params) {
          if (params.hasOwnProperty(prop)) {
            // Check conditions for each property and delete if necessary
            if (params[prop] === '' || params[prop] === null) {
              delete params[prop]
            }
          }
        }

        const res = await this.exportVoyageTripRecords(params)
        saveAs(
          res.data,
          `Trip_Records_${moment().format('YYYYMMDD_HHmmss')}.xlsx`
        )
      } catch (err) {
        console.log(err)
      } finally {
        this.exporting = false
      }
    },
  },
}
</script>
<style>
.column-primary {
  background: #334697;
  color: white;
  /* padding: 4px 12px;
  vertical-align: middle !important; */
}
.title-modal {
  font-weight: 500 !important;
}

.collapsed-row .collapsible-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-out;
  opacity: 0;
}

.expanded-row .collapsible-content {
  max-height: 100px; /* Set to a height that fits the content */
  transition: max-height 0.3s ease-in;
  opacity: 1;
}

.collapsible-content {
  transition: opacity 0.3s ease, max-height 0.3s ease;
}

/* Sticky Column Styles */
.sticky-column {
  position: sticky;
  z-index: 10;
}

.sticky-column-1 {
  left: 0;
  min-width: 200px;
  z-index: 12;
}

.sticky-column-2 {
  left: 200px;
  min-width: 200px;
  z-index: 11;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15) !important;
}

/* Ensure sticky headers have higher z-index */
.column-primary.sticky-column {
  z-index: 15;
}

.column-primary.sticky-column-1 {
  z-index: 17;
}

.column-primary.sticky-column-2 {
  z-index: 16;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15) !important;
}
</style>
